import { Injectable } from '@angular/core';

export interface CampaignDetailForm {
  campaignName: string | null;
  description: string | null;
  goals: string[];
}

@Injectable({
  providedIn: 'root'
})
export class CampaignDetailsService {

campaignDetails: CampaignDetailForm = {
  campaignName: '',
  description: '',
  goals: [],
}

  constructor() {}

  getGoal(goal: string, index: number){
    this.campaignDetails.goals[index] = goal
  }

  removeGoal(index: number) {
    this.campaignDetails.goals.splice(index, 1)
  }

  reset() {
    this.campaignDetails = {
      campaignName: '',
      description: '',
      goals: [],
    }
  }

}
